import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Images/logo2.PNG"
import './Navbar.css'
const Navbar = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container-fluid">
        <a className="navbar-brand ms-4" href="/">
          <img className="main-logo" src={logo} alt=""/>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item me-4">
              <Link className="nav-link active" aria-current="page" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item me-4">
              <Link className="nav-link active" aria-current="page" to="/orders">
                Orders
              </Link>
            </li>
            <li className="nav-item me-4">
              <Link className="nav-link active" aria-current="page" to="/manageBooks">
                Admin
              </Link>
            </li>
            {!user.email && (
              <Link className="nav-link active" to="/deals">
                Deals
              </Link>
            )}
            {user.email && (
              <Link className="nav-link active" to="/checkout">
                Checkout
              </Link>
            )}
            {!user.email && (
              <Link className="btn btn-primary" to="/login">
                Login
              </Link>
            )}
            {user.email && (
              <Link className="nav-link active" to="/profile">
                {user.name}
              </Link>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
